module.exports = __webpack_public_path__ + "img/container3Model.904ec949.png";